export enum ProjectType {
  WindSimX = 1,
  WindSimDesktopHybrid = 2,
}
